import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "15px",
	height: "17px",
	viewBox: "0 0 15 17",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title === undefined ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: "92D913AD-5936-4CC1-9C6C-7D1F7B70BF57"
	}) : title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "UI",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			id: "Registruokit\\u0117s-tyrimui---Errors",
			transform: "translate(-491.000000, -1818.000000)",
			fill: "#0087EF",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M494.415312,1835 C493.502614,1835 492.64454,1834.63491 491.999187,1833.97203 C490.666938,1832.60361 490.666938,1830.377 491.999187,1829.00858 L499.665737,1821.13388 C500.570287,1820.20473 502.042233,1820.20473 502.946783,1821.13388 C503.851372,1822.06302 503.851372,1823.5749 502.946783,1824.50405 L497.307601,1830.29634 C497.083558,1830.5265 496.720238,1830.5265 496.496157,1830.29634 C496.272075,1830.06617 496.272075,1829.69303 496.496157,1829.46286 L502.135339,1823.67053 C502.592491,1823.20097 502.592491,1822.43692 502.135339,1821.96735 C501.913859,1821.73986 501.619431,1821.6146 501.30626,1821.6146 C500.993089,1821.6146 500.698623,1821.73986 500.477181,1821.96735 L492.810631,1829.84206 C491.925819,1830.75089 491.925819,1832.22972 492.810631,1833.13856 C493.239286,1833.57881 493.809167,1833.82128 494.415312,1833.82128 C495.021457,1833.82128 495.591377,1833.57881 496.019993,1833.13856 L503.866482,1825.07903 C504.502272,1824.42597 504.852395,1823.55773 504.852395,1822.63416 C504.852395,1821.71059 504.502272,1820.84234 503.866482,1820.18928 C502.553971,1818.84114 500.418426,1818.84118 499.105954,1820.18928 L493.286833,1826.16636 C493.06279,1826.39653 492.69947,1826.39653 492.475389,1826.16636 C492.251307,1825.9362 492.251307,1825.56305 492.475389,1825.33289 L498.294509,1819.35577 C500.054418,1817.54808 502.918018,1817.54808 504.677926,1819.35577 C505.530492,1820.23144 506,1821.39575 506,1822.63416 C506,1823.87256 505.530492,1825.03683 504.677926,1825.91254 L496.831438,1833.97203 C496.186084,1834.63495 495.32801,1835 494.415312,1835 Z",
				id: "attachment",
				transform: "translate(498.500000, 1826.500000) rotate(-180.000000) translate(-498.500000, -1826.500000) "
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgFile);
export default ForwardRef;
